import React, { useState } from "react";
import { Controller, FormProvider, useForm } from "react-hook-form";
import {
  Box,
  Button,
  Card,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  FormLabel,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Radio,
  RadioGroup,
  Select,
  Stack,
  TextareaAutosize,
  TextField,
  Typography,
} from "@mui/material";
import { Container } from "@mui/system";

import { green } from "@mui/material/colors";
import styled from "@emotion/styled";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import { generateSingleOptions } from "../../FormComponent/FormInputDropdown";
import { optionsUserCategory } from "../../../select-options/options";
import FileUpload from "../FileUpload";
import { useCreatePostJobApiMutation } from "../../../services/apiSlice";

const defaultValues = {
  job_description: "",
  job_categories: "",
  mobile_number: "",

  job_title: "",
  address: "",
  zip_code: "",
  company_name: "",
  email: "",
  company_website: "",
};
//

// const imageUploadSchema = object({
//   image: z.instanceof(File),
//   images: array(z.instanceof(File)),
// });
const PostJob = () => {
  const methods = useForm({ defaultValues: defaultValues });
  const {
    handleSubmit,
    reset,
    control,
    setValue,
    watch,
    register,
    getValues,
    formState: { errors },
  } = methods;

  const navigate = useNavigate();
  const [createPostJobApi, { data, error, isError }] =
    useCreatePostJobApiMutation();
  const [errorNumber, setErrorNumber] = useState("");
  const onSubmit = async (data) => {
    console.log({ data });
    const formData = new FormData();
    if (data.images?.length > 0) {
      console.log("it enter images");
      data.images.forEach((el) => formData.append("images", el));
      formData.append("zip_code", data.zip_code);
      formData.append("job_title", data.job_title);
      formData.append("address", data.address);
      formData.append("job_categories", data.job_categories);
      formData.append("job_description", data.job_description);
      formData.append("email", data.email);
      formData.append("company_website", data.company_website);
      formData.append("mobile_number", data.mobile_number);
      formData.append("company_name", data.company_name);
      try {
        const responseData = await createPostJobApi(formData).unwrap();
        console.log(
          { responseData },
          "responseData?.message",
          responseData?.message
        );
        if (responseData?.success === true) {
          // success message
          Swal.fire("Awesome!", `  ${responseData?.message}`, "success").then(
            (result) => {
              if (result.isConfirmed || result.isDismissed) {
                navigate(`/dashboard/my-job`);
              }
            }
          );
        } else if (isError) {
          //error
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: error?.data?.message,
          });
        } else if (responseData?.success === false) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: error?.data?.message,
          });
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: responseData?.message,
          });
        } else if (error) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: error?.data?.message,
          });
        } else {
          console.log("error", error?.data?.message);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: responseData?.message,
          });
        }
      } catch (error) {
        if (isError) {
          //error
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: error?.data?.message,
          });
        } else {
          console.log("error", error?.data?.message, error?.message);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: error?.data?.message,
          });
        }
      }
    } else {
      console.log("it enter image");
      formData.append("image", data.image);
      formData.append("zip_code", data.zip_code);
      formData.append("job_title", data.job_title);
      formData.append("address", data.address);
      formData.append("job_categories", data.job_categories);
      formData.append("job_description", data.job_description);
      formData.append("email", data.email);
      formData.append("company_website", data.company_website);
      formData.append("mobile_number", data.mobile_number);
      formData.append("company_name", data.company_name);
      try {
        const responseData = await createPostJobApi(formData).unwrap();
        console.log(
          { responseData },
          "responseData?.message",
          responseData?.message
        );
        if (responseData?.success === true) {
          // success message
          Swal.fire("Awesome!", `  ${responseData?.message}`, "success").then(
            (result) => {
              if (result.isConfirmed || result.isDismissed) {
                navigate(`/dashboard/my-job`);
              }
            }
          );
        } else if (isError) {
          //error
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: error?.data?.message,
          });
        } else if (responseData?.success === false) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: error?.data?.message,
          });
        } else if (error) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: error?.data?.message,
          });
        } else {
          console.log("error", error?.data?.message);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: error?.data?.message,
          });
        }
      } catch (error) {
        if (isError) {
          //error
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: error?.data?.message,
          });
        } else {
          console.log("error", error?.data?.message);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: error?.data?.message,
          });
        }
      }
    }
    console.log(data);
  };

  const handleValidate = (value) => {
    const isValid = isValidPhoneNumber(value);
    console.log({ isValid });
    if (!isValid) {
      // error = 'Number not valid'
      setErrorNumber("Not a valid number please try again later!!");
    }
    return isValid;
  };
  const [multipleUpload, setMultipleUpload] = useState(false);
  const methodss = useForm({
    // resolver: zodResolver(imageUploadSchema),
  });
  console.log({ multipleUpload });
  // console.log(methods.formState.errors);

  const onSubmitHandler = (values) => {
    const formData = new FormData();

    if (values.images?.length > 0) {
      values.images.forEach((el) => formData.append("images", el));
    } else {
      formData.append("image", values.image);
    }

    console.log(values);

    // Call the Upload API
    // uploadImage(formData);
  };
  return (
    <>
      <Container maxWidth={"lg"}>
        <Box
          component="form"
          onSubmit={handleSubmit(onSubmit)}
          className="min-h-screen"
          sx={{ mt: 5, ml: 4 }}
          style={{
            display: "flex",

            // padding: "20px",
            // margin: "4px 10px",
            flexDirection: "column",
          }}
        >
          <Card
            style={{
              display: "flex",
              gridRowGap: "20px",
              // padding: "20px",
              // margin: "4px 10px",
              flexDirection: "column",
            }}
            sx={[
              { mx: 3, px: 4 },
              (theme) => ({
                [theme.breakpoints.down("321")]: {
                  width: "100%",
                  py: 3,
                  px: 1,
                  mx: 1,
                },
              }),
            ]}
          >
            <Typography
              variant="h1"
              component="h2"
              className="text-3xl uppercase font-extrabold text-center py-2 md:py-4 "
              sx={{ textAlign: "center" }}
            >
              Find a Pro
            </Typography>
            <TextField
              // id="outlined-basic"
              label="Job Title"
              variant="outlined"
              fullWidth={true}
              size={"small"}
              name="job_title"
              {...register("job_title", {
                required: "Job title is required",
                minLength: {
                  value: 3,
                  message: "Job title  should have at-least 3 characters.",
                },
                pattern: {
                  value: /^[a-zA-Z]{3,}$/,
                  message: "Job title  should contain only characters.",
                },
              })}
              error={Boolean(errors.job_title)}
              helperText={
                errors.job_title && errors.job_title.type === "required"
                  ? errors.job_title.message
                  : errors.job_title && errors.job_title.type === "pattern"
                  ? errors.job_title.message
                  : errors.job_title &&
                    errors.job_title.type === "minLength" &&
                    errors.job_title.message
              }
            />

            <FormControl
              error={Boolean(errors.job_categories)}
              // helperText={errors.user_type?.message}
              size={"small"}
            >
              <InputLabel> What service are you looking for?</InputLabel>

              <Controller
                rules={{
                  required: "Please select   the categories you belong to?",
                }}
                render={({ field }) => (
                  <Select {...field}>
                    {generateSingleOptions(optionsUserCategory)}
                  </Select>
                )}
                name="job_categories"
                control={control}
              />
              <FormHelperText>{errors.job_categories?.message}</FormHelperText>
            </FormControl>

            <TextField
              id="outlined-basic"
              label="E-mail"
              variant="outlined"
              fullWidth
              name="email"
              size={"small"}
              {...register("email", {
                required: "Email is Required",
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                  message: "Invalid email address",
                },
              })}
              error={Boolean(errors.email)}
              helperText={
                errors.email && errors.email.type === "required"
                  ? errors.email.message
                  : errors.email &&
                    errors.email.type === "pattern" &&
                    errors.email.message
              }
            />

            <FormControl error={Boolean(errors.mobile_number)}>
              <Controller
                name="mobile_number"
                control={control}
                rules={{
                  required: "mobile number is Required",

                  minLength: {
                    value: 10,
                    message: "Mobile number should have at-least 11 number.",
                  },
                  maxLength: {
                    value: 13,
                    message:
                      "Mobile number should not be more than 13  numbers.",
                  },
                  pattern: {
                    value:
                      /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/,
                    message: "Invalid mobile number no",
                  },

                  validate: {
                    validate: (value) => {
                      handleValidate(value);
                    },
                  },
                }}
                render={({ field: { onChange, value } }) => (
                  // this is where our react-phone-number-input will go
                  <PhoneInput
                    value={value}
                    onChange={onChange}
                    defaultCountry="US"
                    id="phone-input"
                    country="US"
                    placeholder="Enter phone number"
                    // onlyCountries={["us"]}

                    className="border-4 py-1 px-2  border-gray-300"
                  />
                )}
              />{" "}
              <FormHelperText>{errors.mobile_number?.message}</FormHelperText>
              <FormHelperText>{errorNumber}</FormHelperText>
            </FormControl>

            {/* <TextField
              id="outlined-basic"
              name="mobile_number"
              label="Mobile Number"
              variant="outlined"
              fullWidth
              size={"small"}
              {...register("mobile_number", {
                required: "mobile number is Required",
                valueAsNumber: true,
                minLength: {
                  value: 14,
                  message: "Mobile number should have at-least 11 number.",
                },
                maxLength: {
                  value: 13,
                  message: "Mobile number should not be more than 13  numbers.",
                },
                pattern: {
                  value:
                    /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/,
                  message: "Invalid mobile number no",
                },
              })}
              error={Boolean(errors.mobile_number)}
              helperText={
                errors.mobile_number && errors.mobile_number.type === "required"
                  ? errors.mobile_number.message
                  : errors.mobile_number &&
                    errors.mobile_number.type === "minLength"
                  ? errors.mobile_number.message
                  : errors.mobile_number &&
                    errors.mobile_number.type === "pattern"
                  ? errors.mobile_number.message
                  : errors.mobile_number &&
                    errors.mobile_number.type === "maxLength" &&
                    errors.mobile_number.message
              }
            /> */}
            <TextField
              id="outlined-basic"
              name="address"
              label="Address"
              variant="outlined"
              fullWidth
              size={"small"}
              {...register("address", {
                required: "Please specify your residential address",
              })}
              error={Boolean(errors.address)}
              helperText={errors.address?.message}
            />
            <TextField
              id="outlined-basic"
              name="zip_code"
              label="Zip"
              variant="outlined"
              fullWidth
              size={"small"}
              {...register("zip_code", {
                required: "Please specify your zip code or postal code",
                maxLength: {
                  value: 5,
                  message: "Zip code should not be more than 5  numbers.",
                },
                minLength: {
                  value: 5,
                  message: "Zip code should not be less than 5  numbers.",
                },
              })}
              error={Boolean(errors.zip_code)}
              helperText={
                errors.zip_code && errors.zip_code.type === "required"
                  ? errors.zip_code.message
                  : errors.zip_code && errors.zip_code.type === "minLength"
                  ? errors.zip_code.message
                  : errors.zip_code && errors.zip_code.type === "pattern"
                  ? errors.zip_code.message
                  : errors.zip_code &&
                    errors.zip_code.type === "maxLength" &&
                    errors.zip_code.message
              }
            />

            <>
              <TextField
                id="outlined-basic"
                name="company_name"
                label="Company Name"
                variant="outlined"
                fullWidth
                size={"small"}
                {...register("company_name", {
                  required: "Please provide your company name is required.",
                })}
                error={Boolean(errors.company_name)}
                helperText={errors.company_name?.message}
              />
              <TextField
                id="outlined-basic"
                name="company_website"
                label="Company Website"
                variant="outlined"
                fullWidth
                {...register("company_website")}
                // error={Boolean(errors.company_name)}
                // helperText={errors.company_name?.message}
              />
            </>

            <TextField
              id="outlined-multiline-static"
              label="Job Description"
              multiline
              rows={4}
              name={"job_description"}
              {...register("job_description", {
                required:
                  "Please tell us more about the job to match you with real pro.",
                minLength: {
                  value: 20,
                  message:
                    "Job description  should have at-least 20 characters.",
                },
              })}
              error={Boolean(errors.job_description)}
              helperText={errors.job_description?.message}
            />

            <Box
              display="flex"
              flexDirection="column"
              sx={[
                { width: "80%" },
                (theme) => ({
                  [theme.breakpoints.down("321")]: {
                    width: "100%",
                    py: 3,
                    px: 1,
                    mx: 1,
                  },
                }),
              ]}
            >
              {/* Single Image Upload */}
              <FormProvider {...methods}>
                <Stack marginBottom={2}>
                  <Typography
                    textAlign="center"
                    variant="p"
                    component="p"
                    gutterBottom
                    sx={{
                      // mx: 3,
                      py: 3,
                    }}
                  >
                    Click to
                    {multipleUpload == false
                      ? "  Upload more than one photos of job "
                      : " upload Single photos of job here "}
                    <Button
                      sx={{
                        // background: "transparent",
                        // color: "black",
                        px: 3,
                        py: 2,
                        mx: 3,
                      }}
                      className="rounded-2xl border-green-500 text-black border-2 bg-green-500"
                      onClick={() => setMultipleUpload(!multipleUpload)}
                    >
                      {" "}
                      click here
                    </Button>
                  </Typography>
                  <FileUpload
                    required={
                      "Please upload the photo of  your job description "
                    }
                    limit={multipleUpload === false ? 1 : 4}
                    multiple={multipleUpload === false ? false : true}
                    name={multipleUpload === false ? "image" : "images"}
                  />
                </Stack>
              </FormProvider>
            </Box>

            <FormGroup
              error={Boolean(errors.tnc)}
              style={{ display: "block", marginTop: "17px" }}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    name="tnc"
                    {...register("tnc", {
                      required: "please aggre our terms and condtions",
                    })}
                  />
                }
                label="I agree all terms and conditions"
              />
            </FormGroup>
            <FormHelperText style={{ color: "#d32f2f" }}>
              {errors.tnc?.message}
            </FormHelperText>
            <div className="clearfix"></div>
            <Button
              variant="contained"
              type="submit"
              // size="small"
              className="hover:bg-green-300"
              sx={[
                {
                  color: "white",
                  background: green[600],
                  // width: "40%",
                  // mx: 30,
                  mb: 4,
                  px: 2,
                  py: 2,
                  textAlign: "center",
                  placeItems: "center",
                },
                (theme) => ({
                  [theme.breakpoints.down("321")]: {
                    // width: "80%",
                    py: 3,
                    px: 1,
                    mx: 1,
                  },
                }),
              ]}
            >
              Share Job to Pros
            </Button>
          </Card>
        </Box>
      </Container>
    </>
  );
};

export default PostJob;
